import React ,{Component} from 'react';
import Wrapper from '../../wrapper/Wrapper';
import {connect} from 'react-redux';
import Toolbar from '../../stateless/common/Navigation/Toolbar/Toolbar';
import classes from './Layout.module.css';
import Sidedrawer from '../../stateless/common/Navigation/SideDrawer/SideDrawer';

class Layout extends Component {

    state={
        showSideDrawer : false
    }

    toggleHandler = () => {
        this.setState((previous) => {
            return {showSideDrawer:!previous.showSideDrawer};
        });
    }

    render(){
        return(
            <Wrapper>
                <Toolbar toggle={this.toggleHandler} isLoggedIn={this.props.token}/>
                <Sidedrawer show={this.state.showSideDrawer} toggle={this.toggleHandler}
                    isLoggedIn={this.props.token}/>
                <main className={classes.Layout}>
                {this.props.children}</main>
            </Wrapper>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        ...state.AuthReducer
    }
}

export default connect(mapStateToProps)(Layout);